import { useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  ActiveFilterChipsContainer,
  ClearAllButton,
  CloseIconGlyph,
  FilterChip,
  FilteredByLabel,
} from "./ActiveFilterChips.styles";
import { STATUS_FILTER_OPTIONS } from "./helperContentList";

type ActiveFilterChipsProps = {
  status: string[];
  author: string[];
  // eslint-disable-next-line no-unused-vars
  onRemoveStatus: (value: string) => void;
  // eslint-disable-next-line no-unused-vars
  onRemoveAuthor: (value: string) => void;
  onClearAll: () => void;
};

const ActiveFilterChips = ({
  status,
  author,
  onRemoveStatus,
  onRemoveAuthor,
  onClearAll,
}: ActiveFilterChipsProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (!status.length && !author.length) return null;

  return (
    <ActiveFilterChipsContainer data-testid='active-filter-chips'>
      {!isMobile && <FilteredByLabel>{t("filtered_by")}</FilteredByLabel>}
      {status.map((value) => {
        const labelKey = STATUS_FILTER_OPTIONS.find((opt) => opt.value === value)?.labelKey;
        const statusLabel = labelKey ? t(labelKey) : value;
        return (
          <FilterChip
            key={`status-${value}`}
            data-testid={`active-filter-chip-status-${value}`}
            label={isMobile ? statusLabel : `${t("status")}: ${statusLabel}`}
            onDelete={() => onRemoveStatus(value)}
            deleteIcon={<CloseIconGlyph />}
          />
        );
      })}
      {author.map((value) => (
        <FilterChip
          key={`author-${value}`}
          data-testid={`active-filter-chip-author-${value}`}
          label={isMobile ? value : `${t("author")}: ${value}`}
          onDelete={() => onRemoveAuthor(value)}
          deleteIcon={<CloseIconGlyph />}
        />
      ))}
      <ClearAllButton
        type='button'
        disableRipple
        data-testid='active-filter-clear-all'
        onClick={onClearAll}>
        {t("clear_all")}
      </ClearAllButton>
    </ActiveFilterChipsContainer>
  );
};

export default ActiveFilterChips;
